import React from 'react';
import useStyles from './useStyles';

interface Props {
  headerComponent: React.ReactElement;
  securityComponent: React.ReactElement;
  sheetMetalComponent?: React.ReactElement;
  refComponent: React.ReactElement;
  uploadComponent: React.ReactElement;
  projectInfoComponent: React.ReactElement;
  consultationMethodComponent: React.ReactElement;
  submitComponent: React.ReactElement;
}

const RequestForQuotationPresenter = ({
  headerComponent,
  uploadComponent,
  securityComponent,
  sheetMetalComponent,
  refComponent,
  projectInfoComponent,
  consultationMethodComponent,
  submitComponent
}: Props) => {
  const classes = useStyles();
  return (
    <div className={classes['rfq-container']}>
      {headerComponent}

      {uploadComponent}

      {securityComponent}

      {sheetMetalComponent ? sheetMetalComponent : null}

      {refComponent}

      {projectInfoComponent}

      {consultationMethodComponent}

      {submitComponent}
    </div>
  );
};

export default RequestForQuotationPresenter;
